export function capitalizeFirstLetter(val) {
  if(!val) return val;
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}
